import PgaCoachOfferingCard, { buildPgaCoachOfferingClickAnalyticsPayload } from './pga-coach-offering-card'

export default PgaCoachOfferingCard
export { buildPgaCoachOfferingClickAnalyticsPayload }
